<template>
    <v-card>
        <v-layout>
            <v-flex xs12>
                <v-layout class="notPrinted">
                    <v-flex xs12>
                        <h1 class="text-xs-center">Products</h1>
                    </v-flex>
                </v-layout>
                <v-layout wrap class="notPrinted action-container">
                    <v-flex xs12 sm2 offset-sm1>
                        <v-autocomplete
                            :items="departments"
                            item-text="Name"
                            item-value="ID"
                            v-model="selectedDepartments"
                            label="Department"
                            hint="Department"
                            multiple
                            @change="departmentChanged"
                        ></v-autocomplete>
                    </v-flex>
                    <v-flex xs12 sm2>
                        <v-autocomplete
                            :items="filteredCategories"
                            item-text="Name"
                            item-value="ID"
                            v-model="selectedCategories"
                            label="Category"
                            hint="Category"
                            multiple
                        ></v-autocomplete>
                    </v-flex>
                    <v-flex xs12 sm2>
                        <v-checkbox
                            label="Active Only"
                            v-model="activeOnly"
                        ></v-checkbox>
                    </v-flex>
                    <v-flex xs12 sm2>
                        <v-btn
                            color="accent"
                            block
                            @click="triggerPrint()"
                        >
                            Print
                        </v-btn>
                    </v-flex>
                    <v-flex xs12 sm2>
                        <v-btn
                            color="accent"
                            block
                            @click="exportToExcel()"
                        >
                            Export to Excel
                        </v-btn>
                    </v-flex>
                </v-layout>
                <v-layout>
                    <v-flex xs12>
                        <v-data-table
                            :headers="headers"
                            :items="products"
                            :loading="loading"
                            :search="search"
                            must-sort
                            :rows-per-page-items="rowsPerPage"
                            :pagination.sync="pagination"
                            ref="productsReportDataTable"
                        >
                            <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
                            <template slot="items" slot-scope="props">
                                <tr :data-id="props.item.ID">
                                    <td>{{props.item.Name}}</td>
                                    <td>{{props.item.ProductIDCode}}</td>
                                    <td>{{props.item.ProductComment}}</td>
                                    <td>{{formatCurrency(props.item.CostPrice)}}</td>
                                    <td v-if="props.item.Active"><v-icon color="success">check</v-icon></td>
                                    <td v-if="!props.item.Active"><v-icon color="error">close</v-icon></td>
                                </tr>
                            </template>
                            <template v-if="!loading" slot="no-data">
                                <v-alert v-if="loadError" outline :value="true" color="error" icon="error">
                                    {{loadError}}
                                </v-alert>
                                <v-alert v-if="!loadError" outline :value="true" type="info">
                                    No results found
                                </v-alert>
                            </template>
                        </v-data-table>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
    </v-card>
</template>
<script>
import ErrorAlert from "../common/ErrorAlert"
import formatters from "../../helpers/formatters";
import _ from "underscore";
import ExcelJS from "exceljs";
import FileSaver from "file-saver";

const moment = require("moment");

export default {
    components: {
        ErrorAlert
    },
    props: [
        
    ],
    data() {
        return {
            rowsPerPage: [20, 50, 100, {"text":"$vuetify.dataIterator.rowsPerPageAll","value":-1}],
            pagination: {
                rowsPerPage: 20, // default
                sortBy: "CategorySortOrder"
            },
            selectedDepartments: [],
            selectedCategories: [],
            showEditDialog: false,
            editProductValid: false,
            search: "",
            activeOnly: true,
            headers: [
                {
                    text: "Product Name",
                    value: "Name"
                },
                {
                    text: "Product Code",
                    value: "ProductIDCode"
                },
                {
                    text: "Description",
                    value: "ProductComment"
                },
                {
                    text: "Cost Price",
                    value: "CostPrice"
                },
                {
                    text: "Active",
                    value: "Active"
                }
            ]
        };
    },
    computed: {
        loading() {
            return this.$store.state.productStore.loading;
        },
        loadError() {
            return this.$store.state.productStore.loadError;
        },
        products() {
            return this.$store.state.productStore.products.filter(s => s.Active || !this.activeOnly)
                .filter(p => {
                    // if selected departments is empty, all
                    if (this.selectedDepartments.length == 0){
                        return true;
                    } 
                    // if the product has a filtered category based on the department then return true
                    else {
                        var productCat = this.filteredCategories.find(cat => cat.ID == p.CategoryID);

                        return productCat !== undefined;
                    }
                }, this)
                .filter(p => {
                    // if selected categories is empty, all
                    if (this.selectedCategories.length == 0){
                        return true;
                    } 
                    // if the product has a filtered category based on the department then return true
                    else {
                        return this.selectedCategories.includes(p.CategoryID);
                    }
                }, this);
        },
        categories() {
            return this.$store.state.categoryStore.categories.filter(c => c.Active);
        },
        filteredCategories() {
            return this.categories.filter(x => _.some(x.Departments, function(y) { return this.selectedDepartments.includes(y.DepartmentID) }, this) || this.selectedDepartments.length == 0).sort((a, b) => {
                if(a.SortOrder > b.SortOrder) {
                    return 1
                } else if(a.SortOrder < b.SortOrder) {
                    return -1
                } else {
                    if(a.Name > b.Name) {
                        return 1
                    } else if (a.Name < b.Name) {
                        return -1
                    } else {
                        return 0
                    }
                }
            });
        },
        departments() {
            return this.$store.state.departmentStore.departments.filter(s => s.Active);
        }
    },
    methods: {
        loadProducts() {
            this.$store.dispatch("productStore/loadProducts");
        },
        loadCategories() {
            this.$store.dispatch("categoryStore/loadCategories");
        },
        loadDepartments() {
            this.$store.dispatch("departmentStore/loadDepartments");
        },
        formatCurrency(value) {
            return formatters.formatCurrency(value);
        },
        departmentChanged(){
            this.selectedCategories = [];
        },
        triggerPrint(){
            window.print();
        },
        async exportToExcel() {
            const filename = `ProductsReport_${moment().format("YYYYMMDD_HHmm")}.xlsx`;
            const blobType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';

            // the Vuetify data table has it's own internal implementation of how to sort things
            // we are accessing and using it here, to ensure that the data in our exported file is sorted the same as the data table is sorting it
            // this is totally not supported in any way, it's not in the documentation
            // to have a look at the refs object: console.log(this.$refs.productsReportDataTable)
            let sortedProducts = this.$refs.productsReportDataTable.customSort([...this.products], this.pagination.sortBy, this.pagination.descending);

            // instead of "1" or "0", use some friendly text for active and inactive products
            sortedProducts = sortedProducts.map(function(p) {
                p.ActiveText = p.Active == 1 ? "Active" : "Inactive";

                return p;
            });

            // create base objects
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet("Product Report");

            // set up the worksheet columns so they can be referred to by their keys
            // this also sets up some column styling and widths
            // this also adds a header row automatically, using the "header" property
            worksheet.columns = [
                {
                    header: "Product Name",
                    key: "Name",
                    width: 50,
                    style: {
                        alignment: {
                            wrapText: true
                        }
                    }
                },
                {
                    header: "Product Code",
                    key: "ProductIDCode",
                    width: 50,
                    style: {
                        alignment: {
                            wrapText: true
                        }
                    }
                },
                {
                    header: "Description",
                    key: "ProductComment",
                    width: 50,
                    style: {
                        alignment: {
                            wrapText: true
                        }
                    }
                },
                {
                    header: "Cost Price",
                    key: "CostPrice",
                    width: 10,
                    style: {
                        numFmt: '"$"#,##0.00;[Red]\-"$"#,##0.00'
                    }
                },
                {
                    header: "Active",
                    key: "ActiveText",
                    width: 10
                }
            ];

            // put data into sheet - the library uses the column keys to get the data from each product object
            for (let i=0; i<sortedProducts.length; i++) {
                const row = worksheet.getRow(i + 2); // there is no row 0, and row 1 is the header row
                row.values = sortedProducts[i];
            }
            
            // format header row
            worksheet.getRow(1).font = {
                bold: true
            };

            // write to a buffer and trigger a "download" of the new file
            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], { type: blobType });
            FileSaver.saveAs(blob, filename);
        }
    },
    created() {
        this.loadProducts();

        if (this.categories.length <= 0) {
            this.loadCategories();
        }
        if (this.departments.length <= 0) {
            this.loadDepartments();
        }
    }
};
</script>

<style scoped>
    #app .action-container .flex {
        padding-left: 5px;
        padding-right: 5px;
    }
</style>